
import { db } from '../firebase'; // Import your Firebase setup
import { collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import './OrderManager.css'; // Import the CSS file for styling
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// Function to fetch orders with 'NEW' status
export const fetchNewOrders = async () => {
  const ordersRef = collection(db, 'orders');
  const q = query(ordersRef, where('status', '==', 'new'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

// Function to update an order's status in Firestore
export const updateOrderStatus = async (orderId, status) => {
  const orderDocRef = doc(db, 'orders', orderId);
  await updateDoc(orderDocRef, { status });
};

// Function to update order items in Firestore
export const updateOrderItems = async (orderId, updatedItems) => {
  const orderDocRef = doc(db, 'orders', orderId);
  await updateDoc(orderDocRef, { items: updatedItems });
};

// components/OrderManager.js
const OrderManager = () => {
  const [orders, setOrders] = useState([]);
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [editingItems, setEditingItems] = useState([]);
  const user = useSelector((state) => state.auth.currentUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate('/loginK');
      setOrders([]); // Clear orders if no user
      return;
    }



    // Fetch new orders from Firebase
    const loadOrders = async () => {
      const newOrders = await fetchNewOrders();
      setOrders(newOrders);
    };

    loadOrders();
  }, [user, navigate]); // Added 'user' and 'navigate' as dependencies


  const changeBodyBackground = (background) => {
    document.body.style.background = background;
  };


  useEffect(() => {
    changeBodyBackground('linear-gradient(to bottom, #9aa3e5, rgba(213, 213, 187, 0))');
    return () => changeBodyBackground(''); // Reset background on unmount
  }, []);


  const handleEditOrder = (order) => {
    setEditingOrderId(order.id);
    setEditingItems(order.items);
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...editingItems];
    updatedItems[index][field] = value;
    setEditingItems(updatedItems);
  };

  const handleUpdateOrder = async (orderId) => {
    await updateOrderItems(orderId, editingItems);
    setEditingOrderId(null);

    // Update orders in state
    setOrders((prevOrders) =>
      prevOrders.map((order) =>
        order.id === orderId ? { ...order, items: editingItems } : order
      )
    );
  };

  const handleConfirmOrder = async (orderId) => {
    await updateOrderStatus(orderId, 'waiting for the warehouse');

    // Remove confirmed order from the list
    setOrders((prevOrders) => prevOrders.filter((order) => order.id !== orderId));
  };

  const formatDate = (timestamp) => {
    if (timestamp && timestamp.seconds) {
      const date = new Date(timestamp.seconds * 1000); // Convert seconds to milliseconds
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString(); // Format as date and time
    }
    return '';
  };

  return (
    <div className="order-manager-container">
      <div className="header">
        <h2>Orders Pending: {orders.length}</h2>
      </div>
      {orders.map((order) => (
        <div key={order.id} className="order-card">
          <div className="order-header">
            {/* Ensure order.user.username exists and is rendered correctly */}
            <h4>המזמין : {order.user}</h4>
            <span className="order-date">תאריך: {formatDate(order.orderDate)}</span>
            <span className="order-flag">🚩</span>
          </div>
          {editingOrderId === order.id ? (
            <>
              {editingItems.map((item, index) => (
                <div key={index} className="order-item1">
                  {item.name}
                  <input
                    style={{ border: 'none', width: '50px' }}
                    type="number"
                    value={item.quantity}
                    onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
                    className="item-quantity-input"
                  />
                </div>
              ))}
              <div className="button-group">
                <button onClick={() => handleUpdateOrder(order.id)} className="action-button save-button">שמירת שינוים</button>
                <button onClick={() => setEditingOrderId(null)} className="action-button cancel-button">דחית הזמנה</button>
              </div>
            </>
          ) : (
            <>
              {order.items.map((item, index) => (
                <div key={index} className="">
                  <span>{item.name} - כמ': {item.quantity}</span>
                </div>
              ))}
              <div className="button-group">
                <button onClick={() => handleEditOrder(order)} className="action-button edit-button">עריכה</button>
                <button onClick={() => handleConfirmOrder(order.id)} className="action-button confirm-button">אישור</button>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default OrderManager;
